import { useParamsWithDefaults } from '../../urlParamHooks';
import { channelPerformancePlatformsConfig } from '../../../../constants/mappings';

export const useConfig = () => { // eslint-disable-line import/prefer-default-export
  const { platform } = useParamsWithDefaults();
  const platformConfig = platform ? channelPerformancePlatformsConfig[platform] : {};

  return { platform, platformConfig };
};
